"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BaseModule = void 0;
const inversify_1 = require("inversify");
const lifecycle_1 = require("../application/lifecycle");
const hooks_1 = require("../hooks");
/**
 * Contract for a module.
 *
 * @remarks
 * Modules are a way to organize an application into cohesive blocks of functionality,
 * each focused on a feature area, application business domain, workflow, or common collection of utilities.
 *
 * A module must be a class decorated with the {@link Module} decorator and extending {@link BaseModule}.
 *
 * See: {@link ApplicationLifecycle}
 */
let BaseModule = class BaseModule {
    /**
     * Lifecycle hook called when the module is being initialized.
     * @param config - The module configuration.
     *
     * @remarks
     * Unlike the constructor, you can perform asynchronous operations there.
     */
    initialize(config) {
        // Do nothing by default, can be overriden
    }
    /**
     * Lifecycle hook where dependencies can be registered in the DI container.
     *
     * @remarks
     * At this stage, there is no guarantee that all the other modules have already registered their dependencies.
     * Therefore, it is not safe to try to get a dependency from the container.
     *
     * See {@link configureServices}
     *
     * @param container The DI container
     * @param config - The module configuration.
     */
    registerServices(container, config) {
        // Do nothing by default, can be overriden
    }
    /**
     * Lifecycle hook where dependencies registered in the DI container can be configured.
     *
     * @remarks
     * At this stage, all modules have registered their dependencies in the container.
     * Therefore, it is safe to get a dependency from the container.
     *
     * @param container The DI container
     * @param config - The module configuration.
     */
    configureServices(container, config) {
        // Do nothing by default, can be overriden
    }
    /** {@inheritDoc IApplicationLifecycle.applicationReady} */
    applicationReady(hook) {
        // Do nothing by default, can be overriden
    }
    /** {@inheritDoc IApplicationLifecycle.applicationReady} */
    applicationStarted(hook) {
        // Do nothing by default, can be overriden
    }
    /** {@inheritDoc IApplicationLifecycle.beforeApplicationExit} */
    beforeApplicationExit(hook) {
        // Do nothing by default, can be overriden
    }
};
__decorate([
    hooks_1.Hook(lifecycle_1.ApplicationReadyHook),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [lifecycle_1.ApplicationReadyHook]),
    __metadata("design:returntype", Object)
], BaseModule.prototype, "applicationReady", null);
__decorate([
    hooks_1.Hook(lifecycle_1.ApplicationStartedHook),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [lifecycle_1.ApplicationStartedHook]),
    __metadata("design:returntype", Object)
], BaseModule.prototype, "applicationStarted", null);
__decorate([
    hooks_1.Hook(lifecycle_1.BeforeApplicationExitHook),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [lifecycle_1.BeforeApplicationExitHook]),
    __metadata("design:returntype", Object)
], BaseModule.prototype, "beforeApplicationExit", null);
BaseModule = __decorate([
    inversify_1.injectable()
], BaseModule);
exports.BaseModule = BaseModule;
//# sourceMappingURL=model.js.map